import { render, staticRenderFns } from "./static-page.vue?vue&type=template&id=29bec77d&"
import script from "./static-page.vue?vue&type=script&lang=js&"
export * from "./static-page.vue?vue&type=script&lang=js&"
import style0 from "./static-page.vue?vue&type=style&index=0&id=29bec77d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports